<template>
  <ul-page class="page-course-declaration">
    <template v-slot:left>
      <div class="page-header-left">
        <div class="page-header-title">课程申报信息管理</div>
      </div>
    </template>
    <div class="page-content">
      <div class="declaration-tips">在优学院平台运行的课程，如果需要参与一流本科课程、职业教育在线精品课程等项目申报，课程负责人在这里可以管理申报信息和学期，查看运行数据。</div>
      <div class="declaration-operation">
        <div class="course-label">我申报的课程</div>
        <a class="help-trigger" href="http://help.ulearning.cn/?p=6078" target="_blank">课程运行建议</a>
        <ul-button type="primary" @click="addCourse">添加申报课程</ul-button>
      </div>
      <ul-table class="table-course" border :data="courseList">
        <ul-table-column
          prop="name"
          label="课程名称">
        </ul-table-column>
        <ul-table-column
          prop="name"
          label="申报类别"
          width="200px"
          >
          <template slot-scope="scope">
            <div class="declare-type">{{declareTypeMap[scope.row.declareType]}}</div>
          </template>
        </ul-table-column>
        <ul-table-column
          prop="termCount"
          label="开课期数"
          width="100px">
        </ul-table-column>
           <ul-table-column
          prop="name"
          class-name="col-operate"
           width="240px"
          label="操作">
          <template slot-scope="scope">
            <a href="javascript:;" @click="toTermManager(scope.row)">版本与学期管理</a>
            <a href="javascript:;" @click="modifyCourse(scope.row)">修改</a>
            <a href="javascript:;" @click="deleteCourse(scope.row)">删除</a>
          </template>
        </ul-table-column>
      </ul-table>
      <div class="pagination-wrapper" v-if="total > params.ps">
        <ul-pagination
          layout="prev, pager, next"
          prevText="上一页"
          nextText="下一页"
          :page-size="params.ps"
          @current-change="handleCurrentChange"
          :total="total">
        </ul-pagination>
      </div>
      
    </div>
    <ul-dialog
      :title="newCourse.id ? '修改申报课程' : '添加申报课程'"
      class="dialog-declaration"
      width="800px"
      @open="declarationDialogOpen"
      :visible.sync="declarationDialogVisiable">
      <ul-form ref="courseForm" :model="newCourse" label-width="100px" :rules="rules">
        <ul-form-item prop="name" label="课程名称" class="form-item-name">
          <ul-input v-model="newCourse.name" placeholder="请输入课程名称"></ul-input>
        </ul-form-item>
        <ul-form-item prop="declareType" label="申报类别" class="form-item-type">
          <ul-radio-group v-model.number="newCourse.declareType">
            <ul-radio :label="1">一流本科课程</ul-radio>
            <ul-radio :label="2">职业教育在线精品课程</ul-radio>
            <ul-radio :label="0">其他</ul-radio>
          </ul-radio-group>
        </ul-form-item>
        <ul-form-item prop="courseId" label="源课件" class="form-item-origin">
          <div class="textbook-area">
            <div class="tips">所选课件门户将作为课程评审门户</div>
            <ul-input
              class="search-group"
              placeholder="输入关键词搜索"
              clearable
              suffix-icon="icon-quanshipei-sousuo"
              search
              @search="originTextbookSearch"
              @keydown.native.enter="originTextbookSearch"
              v-model="originKeyword">
            </ul-input>
            <ul class="origin-textbooks-list">
              <li v-for="(item,index) in originTextbookList" :key="index">
                <ul-radio v-model="newCourse.courseId" :label="item.courseId" :disabled="item.allowfreedomreg != 1 || (!!item.declareCourseId && newCourse.originCourseId != item.courseId)">
                  <div class="radio-content">
                    <span class="title">{{item.name}}</span>
                    <span class="status" v-if="item.allowfreedomreg == 1">（ID：{{item.courseId}},创建时间：{{item.createTime | formatDate}}）</span>
                    <span class="status" v-if="item.allowfreedomreg == 0">（未发布）</span>
                  </div>
                </ul-radio>
              </li>
            </ul>
          </div>
        </ul-form-item>
      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitAddCourse">确 定</ul-button>
        <ul-button plain @click="declarationDialogVisiable = false">取 消</ul-button>
      </span>
    </ul-dialog>
  </ul-page>
</template>

<script>
import { getDeclareCourseList,
         getDeclareOriginTextbookList, 
         saveDeclareCourse,
         deleteDeclareCourse
        } from '@/api/courseApi'
import formateDate from '@/mixins/formatDate.js'
export default {
  name: 'page-course-declaration',
  mixins: [formateDate],
  data () {
    return {
      courseList: [],
      declarationDialogVisiable: false,
      declareTypeMap: {
        '0': '其他 ',
        '1': '一流本科课程',
        '2': '职业教育在线精品课程'
      },
      newCourse: {},
      originKeyword: '',
      originTextbookList: [],
      total: 0,
      params: {
        ps: 10,
        pn: 1
      },
      rules: {
        name: [
          { required: true, message: '请填写课程名称', trigger: 'blur' },
          { max: 200, message:'课程名称不能超过200字符', trigger: 'blur' }
        ],
        declareType: [
          { required: true, message: '请选择申报类别', trigger: 'change' }
        ],
        courseId: [
          { required: true, message: '请选择源课件', trigger: 'submit' }
        ]
      }
    }
  },
  created () {
    this.getDeclareCourseList()
  },
  methods: {
    getDeclareCourseList () {
      getDeclareCourseList(this.params)
        .then(({result}) => {
          this.courseList = result.list || []
          this.total = result.total
        })
    },
    handleCurrentChange (val) {
      this.params.pn = val
      this.getDeclareCourseList()
    },
    addCourse () {
      this.declarationDialogVisiable = true
      this.newCourse = {
        name: '',
        courseId: '',
        declareType: 1
      }
      this.getOriginTextbookList()
    },
    declarationDialogOpen () {
      this.$refs['courseForm'] && this.$refs['courseForm'].clearValidate()
      this.getOriginTextbookList()
    },
    originTextbookSearch () {
      this.getOriginTextbookList()
    },
    getOriginTextbookList  () {
      getDeclareOriginTextbookList({ courseName: this.originKeyword })
        .then(({result}) => {
          this.originTextbookList = result
        })
    },
    submitAddCourse () {
      this.$refs['courseForm'].validate(valid => {
        if (valid) {
          saveDeclareCourse(this.newCourse)
            .then(({result}) => {
              this.declarationDialogVisiable = false
              this.getDeclareCourseList()
            })
        }
      })
    },
    deleteCourse (item) {
      this.$confirm('删除申报课程，不会删除关联的源课件和班课，但会删除已设置的学期信息。确定删除吗？', '删除申报课程')
        .then(()=> {
          deleteDeclareCourse(item.id)
            .then(() => {
              this.getDeclareCourseList()
            })
        })
    },
    modifyCourse (item) {
      let course = JSON.parse(JSON.stringify(item))
      this.newCourse = course
      this.newCourse.originCourseId = course.courseId
      this.declarationDialogVisiable = true
    },
    toTermManager (item) {
      this.$router.push({
        name: 'termManager',
        query: {
          courseId: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-course-declaration{
  .page-content{
    padding: 20px;
    .declaration-operation{
      margin-top: 20px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .course-label{
        flex: 1;
        font-weight: bold;
        font-size: 20px;
      }
      .help-trigger{
        color: $--color-link;
        margin-right: 10px;
      }
    }
    .table-course{
      .col-operate{
        a{
          margin-right: 10px;
          color: $--color-link;
        }
      }
    }
  }
  .pagination-wrapper{
    padding-top: 20px;
    text-align: center;
  }
  .dialog-declaration{
    .ul-form{

    }
    .form-item-name{
      .ul-input{
        width: 600px;
      }
    }
    .form-item-type{
      .ul-radio{
        width: 100%;
        line-height: 36px;
      }
    }
    .form-item-origin{
      .tips{
        font-size: 12px;
        color: $--color-text-secondary;
      }
      ::v-deep{
        &.is-error{
          .ul-input__inner{
            border-color: $--border-color-base;
          }
        }
      }
    }
    .textbook-area{
      .search-group {
        width: 300px;
      }
      .origin-textbooks-list{
        min-height: 240px;
        max-height: 360px;
        margin-top: 6px;
        overflow: auto;
      }
      .radio-content{
        display: inline-block;
      }
    }
  }
}
</style>